<template>
    <div class="knowledge-graph">
        <el-button
            class="fullscreen-button"
            size="mini"
            icon="el-icon-full-screen"
            aria-label="全屏展示知识图谱"
            @click="fullscreen = true"
        >全屏展示</el-button>
        <disease-chart :option="graphOption" :height="height" />

        <el-dialog
            :title="title"
            :visible.sync="fullscreen"
            fullscreen
            append-to-body
            destroy-on-close
            :show-close="false"
            custom-class="disease-graph-fullscreen"
            @opened="resizeFullscreenChart"
        >
            <div slot="title" class="fullscreen-header">
                <span>{{ title }}</span>
                <el-button size="small" icon="el-icon-close" @click="fullscreen = false">退出全屏</el-button>
            </div>
            <disease-chart
                v-if="fullscreen"
                ref="fullscreenChart"
                :option="graphOption"
                height="100%"
            />
        </el-dialog>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import { buildGraphOption } from './buildGraphOption';

export default {
    name: 'KnowledgeGraph',
    components: { DiseaseChart },
    props: {
        // 所有模块统一接收科研接口格式：{ nodes: [{ id, label, degree, distance }],
        // edges: [{ source, target, label, value }] }，不直接传入 ECharts nodes/links。
        graphData: {
            type: Object,
            default: () => ({ nodes: [], edges: [] }),
        },
        title: { type: String, default: '知识图谱' },
        height: { type: String, default: '480px' },
    },
    data() {
        return { fullscreen: false };
    },
    computed: {
        graphOption() {
            return buildGraphOption(this.graphData);
        },
    },
    methods: {
        resizeFullscreenChart() {
            // 弹窗动画结束后重新测量，确保全屏画布使用实际可用尺寸。
            if (this.$refs.fullscreenChart) this.$refs.fullscreenChart.handleResize();
        },
    },
};
</script>

<style lang="less" scoped>
.knowledge-graph {
    position: relative;

    .fullscreen-button {
        position: absolute;
        top: -30px;
        right: 0;
        z-index: 1;
        color: #165DFF;
        border-color: #C6DEFF;
    }
}
</style>

<!-- 全屏弹窗挂载到 body，专属类名避免影响其他弹窗。 -->
<style lang="less">
.disease-graph-fullscreen.el-dialog {
    display: flex;
    flex-direction: column;

    .el-dialog__header {
        flex: none;
        padding: 16px 20px;
        border-bottom: 1px solid #E8EEF8;
    }

    .fullscreen-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #0C55AA;
        font-size: 16px;
        font-weight: bold;
    }

    .el-dialog__body {
        flex: 1;
        min-height: 0;
        padding: 16px 20px;
    }
}
</style>
